import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

import { isRateLimitError, notifyRateLimited } from "./rate-limit-notifier";

/**
 * Surfaces a rate-limit (HTTP 429) rejection as a toast. The cache-level
 * `onError` fires for every failed query/mutation regardless of a hook's
 * `throwOnError` setting, so this is the single place a 429 is caught for all
 * server state.
 */
const handleCacheError = (error) => {
  if (isRateLimitError(error)) {
    notifyRateLimited();
  }
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: handleCacheError }),
  mutationCache: new MutationCache({ onError: handleCacheError }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});
